(function($) {
    $(function() {
        $('a img[src*="_off."], input[src*="_off."]').rollOver();
        $('a[href^="#"]').smScroll();
    });

    /**
     * Radio Block
     */
    $('.radio-block input[type="radio"]').on('change', function() {
        var $parent = $(this).closest('label');
        var name    = $(this).attr('name');

        $('input[name="'+name+'"]:not(:checked)')
            .closest('label').removeClass('active');

        if($(this).prop('checked')) {
            $parent.addClass('active');
        } else {
            $parent.removeClass('active');
        }
    }).trigger('change');

    /**
     * Get Address
     */
    $(function() {
        var $trigger = $('.get_addr_trigger');

        $trigger.each(function() {
            var $zipInput = $($(this).data('input-zip'));
            var $display  = $($(this).data('target'));

            $(this).on('click', function(e) {
                $display.empty();

                // Dummy text
                var results = [
                    '東京都港区赤坂１丁目',
                    '東京都港区赤坂2丁目',
                ];

                $.each(results, function(i, v) {
                    $display
                        .append($('<a>').text(v))
                        .append('<br>');
                });

                return false;
            });
        });
    });
})(jQuery);
